/* eslint-disable */
angular.module('dashboard')
    .controller('dashboardInstallationCtrl', function($state, DashboardService, DynamicColorService, $log, $scope, installationId, socketService, $rootScope, $window, UserService,plants,$uibModal,MapService){
        $scope.getColorForItem = DynamicColorService.getColorForItem;
        var _openDetailPage = function(symbol){
            var url;
            if(angular.isUndefined(symbol.r_symbolconfiguration.$type)){//views
                url=$state.href('modal', {installationId: $scope.installationId,viewId:symbol.r_symbolconfiguration.Id});
                // VIEWS
                // url = $state.href('dashboardview', {
                //     installationId: $scope.installationId,
                //     viewId: symbol.r_symbolconfiguration.Id
                // });
            }else{
                url = $state.href('standAloneMap', { installationId: $scope.installationId, mapId: symbol.r_idsymbol});
            }
            if(url){
                var varNum = Math.floor(Math.random()*999999999);
                url+=(url.indexOf('?')>-1?'&':'?')+varNum;
                $window.open(url, '_blank', "width=1024, height=720, top=50, left=100");
            }else{
                $log.error('no page found');
            }
        };
        var _openInSamePage = function(symbol){
            if(angular.isUndefined(symbol.r_symbolconfiguration.$type)){//views
                $scope.selectedMap = undefined;
                $scope.selectedView = symbol.r_symbolconfiguration.Id;
            }else{
                $scope.selectedView = undefined;
                $scope.selectedMap = symbol.r_idsymbol;//TODO complete
            }
        };
        var _updateState = function(){
            DashboardService.getSymbolsWithCounterForMaps($scope.installationId).then(function(response){
                angular.forEach(response, function(symbol){
                    if(angular.isUndefined(symbol.r_symbolconfiguration.$type) || symbol.r_symbolconfiguration.$type === null){
                        //views
                        $scope.views[ symbol.r_symbolconfiguration.Id ].counter = symbol.counter;
                    }else{
                        //maps
                        $scope.maps[ symbol.r_idsymbol ].r_state = symbol.r_state;
                    }
                });
            }).catch(function(error){
                $log.error(error);
            });
        };
        $scope.openDetail = function(symbol){
            if($scope.sameWindow){
                _openInSamePage(symbol);
            }else{
                _openDetailPage(symbol);
            }
            _updateState()
        };
        var viewUpdateEventHandler = function(event, jsData){
            $log.debug('incoming message from ws service', jsData);
            $scope.$apply(function(){
                try{
                    // noinspection EqualityComparisonWithCoercionJS
                    if(!jsData.installationId || jsData.installationId != $scope.installationId){
                        $log.error('Rejected message from ws service, no match with current installation', jsData);
                        return;
                    }
                    var eventsData = jsData.data;
                    eventsData.forEach(function(eventData){
                        if(angular.isUndefined(eventData.ViewId) || angular.isUndefined(eventData.Type)){
                            return;
                        }

                        /**
                         * Find view counter to be updated
                         */
                        if($scope.views[ eventData.ViewId ] && $scope.views[ eventData.ViewId ].CounterQueryId === eventData.QueryId && angular.isDefined($scope.views[ eventData.ViewId ].counter)){
                            switch(eventData.Type){
                                case 'ADD':
                                case 0:
                                    $scope.views[ eventData.ViewId ].counter = $scope.views[ eventData.ViewId ].counter + 1;
                                    break;
                                case 'REMOVE':
                                case 1:
                                    $scope.views[ eventData.ViewId ].counter = $scope.views[ eventData.ViewId ].counter - 1;
                                    break;
                                default:
                                    $log.debug("no event");
                                    break;
                            }
                        }
                    });
                }catch(err){
                    $log.error(err);
                    //$scope.eventList.push({ tokens: ['MSG_DECODE_ERR', data]})
                }
            });
        };
        var socketListenerView = $rootScope.$on('socket:view', viewUpdateEventHandler);
        var socketListenerRefresh = $rootScope.$on('socket:refresh', _updateState);
        var socketListenerMap = $rootScope.$on('socket:map', function(event, payload){
            $scope.$apply(function(){
                // noinspection JSUnresolvedVariable
                var symbolsData = payload.data;
                for(var i = 0; i < symbolsData.length; i++){
                    var variationSymbol = symbolsData[ i ];
                    // noinspection JSUnresolvedVariable
                    if($scope.maps[ variationSymbol.IdSymbol ] !== undefined){
                        // noinspection JSUnresolvedVariable
                        $log.debug('updating symbol state', $scope.maps[ variationSymbol.IdSymbol ]);
                        // noinspection JSUnresolvedVariable
                        $scope.maps[ variationSymbol.IdSymbol ].r_state = variationSymbol.State;
                        // noinspection JSUnresolvedVariable
                        $scope.maps[ variationSymbol.IdSymbol ].r_command = variationSymbol.Command;
                    }
                }
            });
            $scope.$apply();
        });
        $scope.setButtonWidth = function(installationId){
            var groupSettings = UserService.getGroupSettingsByInstallationId(installationId);
            $scope.numberOfButtons = groupSettings.LG || 10;
            var width = $window.innerWidth;
            if(width < 1200 && width >= 992){
                $scope.numberOfButtons = $scope.groupSettings.MD || 10;
            }
            if(width < 992){
                $scope.numberOfButtons = $scope.groupSettings.XS || 10;
            }
            console.log($scope);
            $scope.buttonWidth = Math.floor(($window.innerWidth - 30) / $scope.numberOfButtons) + 'px';
        };

        function _init(){
            $scope.plants=plants;
            $scope.installationId = installationId;
            $scope.selectedView = undefined; //not needed but usefull for testing
            $scope.groupSettings = UserService.getGroupSettingsByInstallationId(installationId);
            $scope.sameWindow = $scope.groupSettings.singleWindow || false; //TODO handle with user preference
            $scope.setButtonWidth(installationId);
            DashboardService.getSymbolsWithCounterForMaps($scope.installationId).then(function(response){
                $scope.symbols = response;
                $scope.views = $scope.symbols.filter(function(item){
                    return angular.isUndefined(item.r_symbolconfiguration.$type) || item.r_symbolconfiguration.$type === null;
                }).reduce(function(views, item){
                    views[ item.r_symbolconfiguration.Id ] = item;
                    return views;
                }, {});
                $scope.maps = $scope.symbols.filter(function(item){
                    return angular.isDefined(item.r_symbolconfiguration.$type) && item.r_symbolconfiguration.$type === "SMOWKE.Library.NodeSymbol, SMOWKE.Library";//TODO use constant
                }).reduce(function(maps, item){
                    maps[ item.r_idsymbol ] = item;
                    return maps;
                }, {});
                $scope.subribedTopic = socketService.subscribe('Installation.' + $scope.installationId);
            }).catch(function(error){
                $log.error(error);
            });
        }

        $scope.com90Socket = $rootScope.$on('socket:com90', function(event, data){
            $log.debug('controller Received Feedback');
            if(data.MSG && data.MSG.evntType && data.MSG.evntType == "150"){
                if(data.MSG.plant){
                    var number = data.MSG.Message.match(/[0-9]+/)[0];

                    MapService.getVideocloudInfo({ "idInstallation" : data.INSTALLATION_ID, "plant" : data.MSG.plant, "number" : number}).then(function(result){
                        // var streamVideocloudId = 1;
                        // if (this.gemssNodeInstance.r_symbolconfiguration.videoCloudChannelId && this.gemssNodeInstance.r_symbolconfiguration.videoCloudGUID != ""){
                        //     streamVideocloudId = this.gemssNodeInstance.r_symbolconfiguration.videoCloudChannelId;
                        // }
                        var resultData = result;
                        return $uibModal.open({
                            backdrop : false,
                            animation: true,
                            ariaLabelledBy: 'modal-title',
                            ariaDescribedBy: 'modal-body',
                            templateUrl: 'app/maps/askVideoModal/askVideoModal.tpl.html',
                            controller: 'askVideoModalCtrl',
                            resolve: {
                                symbolDescription: function(){
                                  return resultData.r_videoclouddescription;  
                                },
                                callback: function(){
                                    return function(){
                                        if(window.navigator.userAgent.indexOf("Safari") > -1 && window.navigator.userAgent.indexOf("Chrome") == -1){
                                            console.log('è iOS');
                                            window.open(window.location.origin + window.location.pathname + '#!/error', '_blank', "width=500, height=500, top=50, left=100");
                                        }else{
                                        window.open(window.location.origin + window.location.pathname + '#!/videocloud/'+ resultData.r_videocloudguid + '/' + resultData.r_videocloudchannelid+'?name='+resultData.r_videoclouddescription, '_blank', "width=500, height=500, top=50, left=100");
                                        }
                                    };
                                }
                            }
                        });
                        
                    })
                   
                }
            }
            $scope.$apply();
        });

        window.onresize = function(){
            $scope.setButtonWidth(installationId)
        };
        _init();
        $scope.$on('$destroy', function(){
            socketListenerView();
            socketListenerMap();
            socketListenerRefresh();
            socketService.unsubscribe($scope.subribedTopic);
            $scope.com90Socket();
        });
    });
